export default __webpack_public_path__ + "static/media/select-usage.fcba7a42.svg";